import type { AnchorHTMLAttributes } from "react";

export function Brand(props: AnchorHTMLAttributes<HTMLAnchorElement>) {
  const { className, ...anchorProps } = props;
  return <a {...anchorProps} className={["ui-brand", className].filter(Boolean).join(" ")}>Conferis</a>;
}
